<template>
  <div>
    <template v-if="renderContent">
      <div
        class="tab"
        :class="isActive ? 'tab__active' : 'tab__inactive'"
        :aria-hidden="isActive ? false : true"
      >
        <slot />
      </div>
    </template>
    <template v-else>
      <div
        v-if="isActive"
        class="tab"
        :class="isActive ? 'tab__active' : 'tab__inactive'"
        :aria-hidden="isActive ? false : true"
      >
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "g-tabs-content",
  props: {
    renderContent: Boolean,
    title: {
      type: String,
      default: "Tab",
    },
  },
  data: () => ({
    isActive: false,
  }),
};
</script>

<style lang="scss" scoped>
.tab {
  opacity: 1;
  overflow-wrap: break-word;
  transition: opacity ease-in-out 0.05s;

  &__inactive {
    height: 0;
    padding: 0 !important;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
  }
}
</style>
